import React, {useEffect, useRef} from "react";

const CURSOR_OUTER_DELAY = 0.32;

const CustomCursor = () => {
    const innerRef = useRef(null);
    const outerRef = useRef(null);
    const frameRef = useRef(null);
    const outerPosition = useRef({x: 0, y: 0});
    const targetPosition = useRef({x: 0, y: 0});
    const isVisible = useRef(false);

    useEffect(() => {
        if (!window.matchMedia("(pointer: fine)").matches) {
            return undefined;
        }

        const inner = innerRef.current;
        const outer = outerRef.current;

        if (!inner || !outer) {
            return undefined;
        }

        const showCursor = () => {
            if (isVisible.current) {
                return;
            }

            isVisible.current = true;
            inner.style.opacity = "1";
            outer.style.opacity = "1";
        };

        const hideCursor = () => {
            isVisible.current = false;
            inner.style.opacity = "0";
            outer.style.opacity = "0";
        };

        const updateOuterCursor = () => {
            outerPosition.current.x += (targetPosition.current.x - outerPosition.current.x) * CURSOR_OUTER_DELAY;
            outerPosition.current.y += (targetPosition.current.y - outerPosition.current.y) * CURSOR_OUTER_DELAY;
            outer.style.transform = `translate3d(${outerPosition.current.x}px, ${outerPosition.current.y}px, 0)`;
            frameRef.current = window.requestAnimationFrame(updateOuterCursor);
        };

        const handleMouseMove = (event) => {
            const x = event.clientX;
            const y = event.clientY;

            targetPosition.current = {x, y};
            inner.style.transform = `translate3d(${x}px, ${y}px, 0)`;

            if (!isVisible.current) {
                outerPosition.current = {x, y};
                outer.style.transform = `translate3d(${x}px, ${y}px, 0)`;
                showCursor();
            }
        };

        const handleMouseDown = () => {
            inner.classList.add("custom-cursor__inner--active");
            outer.classList.add("custom-cursor__outer--active");
        };

        const handleMouseUp = () => {
            inner.classList.remove("custom-cursor__inner--active");
            outer.classList.remove("custom-cursor__outer--active");
        };

        document.body.classList.add("has-custom-cursor");
        frameRef.current = window.requestAnimationFrame(updateOuterCursor);

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mousedown", handleMouseDown);
        window.addEventListener("mouseup", handleMouseUp);
        window.addEventListener("mouseleave", hideCursor);
        window.addEventListener("blur", hideCursor);

        return () => {
            document.body.classList.remove("has-custom-cursor");
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mousedown", handleMouseDown);
            window.removeEventListener("mouseup", handleMouseUp);
            window.removeEventListener("mouseleave", hideCursor);
            window.removeEventListener("blur", hideCursor);
            window.cancelAnimationFrame(frameRef.current);
        };
    }, []);

    return (
        <>
            <div ref={outerRef} className="custom-cursor custom-cursor__outer"/>
            <div ref={innerRef} className="custom-cursor custom-cursor__inner"/>
        </>
    );
};

export default CustomCursor;
